
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent, defineEmits } from 'vue';


export default defineComponent({
    name: "StepNav",
    props: {
        stepViews: {
            type: Array,
            required: true,
        },
        step: {
            type: Number,
            required: true,
        },
        changeStep: {
            type: Function,
            required: false,
        },
        hideServiceView: {
            type: Boolean,
            required: false,
        },
    },
    emits: ['changeStep'],
    setup(props, { emit }) {
        const changeStep = (step) => {
            emit('changeStep', step);
        }

        return {
            changeStep,
            translate,
        }
    }

})
